<div class="participant-autocomplete d-flex flex-column mt-3 mt-lg-0" data-cy="participant-comparition-box">
    <header class="participant-autocomplete__header">{{ 'web.participant_comapre_head' | translate }}</header>
    <div class="participant-autocomplete__item">
        @if (participantFirst === null) {
        <input
            matInput
            #first
            placeholder="{{ 'web.enter_' + who + '_first' | translate }}"
            type="search"
            autocomplete="off"
            data-cy="input-participant-one"
            class="form-control participant-autocomplete__field"
        />
        <div class="participant-autocomplete__items" data-cy="search-result">
            @for (data of $first | async; track $index) {
            <div class="--items-val" (click)="selectParticipant('first', data)">
                <img class="mr-2" height="20" [src]="data.image" [alt]="data.name" />
                {{ data.name }}
                @if (data.tournaments && data.tournaments!.length > 0) {
                <small>
                    - {{ data.tournaments[0].sub_tournament_name }} ({{ data.tournaments[0].category_name }})
                </small>
                }
            </div>
            }
        </div>
        } @else {
        <div class="participant-autocomplete__selected">
            <img class="mr-2" height="20" [src]="participantFirst?.image" [alt]="participantFirst?.name" />
            {{ participantFirst?.name }}
            @if (participantFirst?.tournaments && (participantFirst?.tournaments)!.length > 0) {
            <small>
                - {{ participantFirst.tournaments[0].sub_tournament_name }} ({{
                    participantFirst.tournaments[0].category_name
                }})
            </small>
            } &nbsp;&nbsp;&nbsp;&nbsp;<i class="fas fa-times alert-color app-cursor" (click)="resetVal('first')"></i>
        </div>
        }
    </div>
    <div class="participant-autocomplete__item">
        @if (participantSecond === null) {
        <input
            matInput
            #second
            placeholder="{{ 'web.enter_' + who + '_second' | translate }}"
            type="search"
            autocomplete="off"
            data-cy="input-participant-two"
            class="form-control participant-autocomplete__field"
        />
        <div class="participant-autocomplete__items" data-cy="search-result">
            @for (data of $second | async; track $index) {
            <div class="--items-val" (click)="selectParticipant('second', data)">
                <img class="mr-2" height="20" [src]="data.image" [alt]="data.name" />
                {{ data.name }}
                @if (data.tournaments && data.tournaments!.length > 0) {
                <small>
                    - {{ data.tournaments[0].sub_tournament_name }} ({{ data.tournaments[0].category_name }})
                </small>
                }
            </div>
            }
        </div>
        } @else {
        <div class="participant-autocomplete__selected">
            <img class="mr-2" height="20" [src]="participantSecond?.image" [alt]="participantSecond?.name" />
            {{ participantSecond?.name }}
            @if (participantSecond?.tournaments && (participantSecond?.tournaments)!.length > 0) {
            <small>
                - {{ participantSecond.tournaments[0].sub_tournament_name }} ({{
                    participantSecond.tournaments[0].category_name
                }})
            </small>
            } &nbsp;&nbsp;&nbsp;&nbsp;<i class="fas fa-times alert-color app-cursor" (click)="resetVal('second')"></i>
        </div>
        }
    </div>
    <button
        data-cy="button-search"
        class="btn btn-primary btn-block rounded-0 mt-3"
        [disabled]="!isValid"
        (click)="doCompare()"
    >
        @if (!loading) {
        {{ 'web.search_compare' | translate }}
        } @else {
        {{ 'web.searching' | translate }} ... }
    </button>
</div>
